import { graphql } from 'react-relay';

export const DELETE_PROMOTIONAL_CODE_MUTATION = graphql`
  mutation DeletePromotionalCodeMutation($id: ID!) {
    DeletePromotionalCode(id: $id)
  }
`;
